import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Day from 'dayjs';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/es';
import AddressService from "services/Address";
import StorageService from 'services/StorageService';
import CartService from 'services/Cart';
import PubSub from "services/PubSub";
import { actionsType } from 'config/constants';
import AddressFactory from 'factories/Address';
import Tooltip from 'components/Tooltip';
import { useIsMounted } from 'hooks';
import ExpressDeliveryService from 'services/ExpressDelivery';
import { useViewportMediaQuery } from 'hooks';
import TagManagerService from 'services/TagManager';
import SalesChannel from 'services/SalesChannel';
import style from './style.scss';//NOSONAR

let actions = {};

const BannerHour = (props) => {
    const helpCenter = typeof window !== 'undefined' && (window.location.pathname.indexOf('/centro-ayuda') !== -1);
    if(helpCenter) return '';
    const isMobile = useViewportMediaQuery('1024');

    const id = props && props.id ? props.id : 0;
    const method = StorageService.getItem('preselected_shipping_method');
    const [timeExpress, setTimeExpress] = useState('');
    const [date, setDate] = useState(null);
    const [shippingCost, setShippingCost] = useState('');
    const [show, setShow] = useState(true);
    const isMounted = useIsMounted();

    useEffect(() => {
        getDateDelivery();

    }, []);

    useEffect(() => {
        if (!actions[id]) {
            actions[id] = [];
        }


        actions[id].push(PubSub.register(actionsType.SET_SALES_CHANNEL, getDateDelivery));
        actions[id].push(PubSub.register('message_info_chat', getMessageInfo));

        if(!isMobile) setShow(true);

        return function cleanup() {
            actions[id].map(token => PubSub.unregister(token));
            actions[id] = [];
        }

    }, [isMobile]);

    const getDateDelivery = () => {
        const address = StorageService.getSecureItem('address');
        const sc = StorageService.getSecureItem('sales_channel');
        const methodType = SalesChannel.getMethodName();
        const formatMethod = AddressFactory.getFormatedMethod(methodType);
        const methodTranslate = trasnlateMethod(methodType);
        setShippingCost(methodTranslate);

        if (methodType === 'seller-1-sla-Express') {
            setTimeExpress(CartService._expressTime())

        } else {
            AddressService.getHoursDelivery(address, sc, formatMethod).then(result => {
                if (isMounted.current) {
                    const _sla = (result && result.data) ? result.data.sla : null;
                    setDate(_sla);
                    if (_sla) {
                        if (!StorageService.getItem('windowSent')) {
                            TagManagerService.offeredWindow(_sla.startDateUtc, _sla.endDateUtc, sc, formatMethod);
                            StorageService.setItem('windowSent', true);
                        }
                    }
                    if (_sla && (methodType === 'seller-1-sla-DespachoaDomicilio')) {
                        StorageService.setItem('cost_estimate', _sla.listPrice)
                    } else {
                        StorageService.removeItem('cost_estimate');
                    }
                }
            })
        }
    }

    const getMessageInfo = (payload) => {
        if(isMobile && payload.value) {
            setShow(!payload?.value?.visibility);
        }
    }

    const trasnlateMethod = (methodType) => {
        switch (methodType) {
            case 'seller-1-sla-RetiroenTienda':
                return "Costo de retiro";
            case 'seller-1-sla-ClickalAuto':
                return "Costo de retiro";
            case 'seller-1-sla-DespachoaDomicilio':
                return "Costo despacho";
            case 'seller-1-sla-Express':
                return "Costo despacho";
            default:
                return '';
        }
    }


    const [express, setExpress] = useState(false)

    useEffect(() => {
        if(date){
            ExpressDeliveryService.getExpressFormat(date).then((res) => {
                setExpress(res)
            })
        }else{
            setExpress(false)
        }
    }, [date])

    const formatDate = (dateFormat) => {
        if (!dateFormat) return false;

        let formatExpress = express

        if (formatExpress) {
            let hourEnd = Day.extend(utc)(dateFormat.endDateUtc).utc().format('HH:mm');
            return `Hoy, antes de las ${hourEnd} hrs`;
        } else {
            const dayName = Day(dateFormat.startDateUtc).locale('es').format('ddd DD');
            let newDay = dayName.charAt(0).toUpperCase() + dayName.slice(1).replace('.', '');
            const month = Day(dateFormat.startDateUtc).locale('es').format('MM');
            const newMonth = month.charAt(0).toUpperCase() + month.slice(1);
            const hour = Day.extend(utc)(dateFormat.startDateUtc).utc().format('HH:mm');


            if (Day(dayName).locale('es').format('YYYY-MM-DD') === Day().locale('es').format('YYYY-MM-DD')) {
                return 'Hoy' + ' a las ' + hour + ' hrs';
            } else {
                return newDay + '/' + newMonth + ' - ' + hour + ' hrs';
            }
        }
    }

    const priceFormat = (number) => (number && number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'));

    if (!(date && show)) return '';

    return (
        <div className="banner-hour-container" >
            <Tooltip message='La disponibilidad de este horario podría cambiar dependiendo de la demanda  o la cantidad de productos solicitados.' button='Entendido' timer={10000} once={true} type='tooltip_hour_info'>
                {(visible) => {
                    return <div className={"banner-hour-items-container" + (visible ? ' visible' : '')}>
                        <div className="banner-shipping-wrapper">
                            <span className="banner-hour-span">{shippingCost}</span>
                            <span className="items-price">{'$' + priceFormat(date.listPrice)}</span>
                        </div>
                        <span className="item-split-bar">|</span>
                        <div className="banner-hour-wrapper">
                            <span className="banner-hour-span">Desde</span><span className="banner-hour-date">{(method === 'seller-1-sla-Express') ? `${timeExpress} minutos` : formatDate(date)}</span>
                        </div>
                    </div>
                }}
            </Tooltip>
        </div>
    )
}

BannerHour.propTypes = {
    id: PropTypes.number
}

export default BannerHour;
